import React from 'react';
import BaseGenerateDocumentButton from './BaseGenerateDocumentButton';
import { logEvent } from '../../analytics';

export default function GenerateDocumentButton({patient, onGenerateClicked, fromEmptyState = false}) {
  const handleGenerateClicked = () => {
    logEvent('PatientDetails', 'GenerateDocument');
    onGenerateClicked?.();
  };

  return (
    <BaseGenerateDocumentButton
      patient={patient}
      onGenerateClicked={handleGenerateClicked}
      buttonProps={{
        size: fromEmptyState ? 'large' : 'middle',
        type: 'primary'
      }}
    />
  );
}